export default "__VITE_ASSET__8f3270fb__"